/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Update_Payment_Method_QuestionInputs */

const en_mobile_faq_update_payment_method_question = /** @type {(inputs: Mobile_Faq_Update_Payment_Method_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating your payment method`)
};

const es_mobile_faq_update_payment_method_question = /** @type {(inputs: Mobile_Faq_Update_Payment_Method_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar tu método de pago`)
};

/**
* | output |
* | --- |
* | "Updating your payment method" |
*
* @param {Mobile_Faq_Update_Payment_Method_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_update_payment_method_question = /** @type {((inputs?: Mobile_Faq_Update_Payment_Method_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Update_Payment_Method_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_update_payment_method_question(inputs)
	return en_mobile_faq_update_payment_method_question(inputs)
});